import * as React from 'react';
import { IgcNavDrawerHeaderItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A wrapper for navigation drawer's header.
 * @slot  - Renders the header content
 * @class
 */
export const IgrNavDrawerHeaderItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-nav-drawer-header-item',
  displayName: 'IgrNavDrawerHeaderItem',
  elementClass: Component,
  react: React,
});

export type IgrNavDrawerHeaderItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrNavDrawerHeaderItemModule = Component;
